<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/incomes">{{$t('income_list')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('sale_receipt_create')}} [{{model.DocSourceNo}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('customer')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.CustomerName" readonly/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Date.$error }">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="$v.model.Date.$model"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('invoice_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.DocSourceNo" readonly/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.AccountId.$error }">
                                <label class="label-control blue">{{$t('payment_method')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.model.AccountId.$model">
                                        <option value=""></option>
                                        <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>                 
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('balance')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" v-model="model.Balance" readonly/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Amount.$error }">
                                <label class="label-control blue">{{$t('amount')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" min="0" v-model="$v.model.Amount.$model"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group class="label-control" :label="$t('description')" :class="{ 'form-group-error': $v.model.Description.$error }">
                                <b-form-textarea v-model="$v.model.Description.$model"/>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model: {
                    Date: '',
                    AccountId: '',
                    Amount: '',
                    Description: ''
                },
                banks: [],
                actionLink: 'sale/receipt/save'
            }
        },
        validations:{
            model: {
                Date: { required },
                AccountId: { required },
                Description: { required },
                Amount: { required, minValue: minValue(0) }
            }
        },
        created: function(){
            this.bankList();
            var id = this.$route.params.id;
            this.findById(id);
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('sale/invoice/paid', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        let header = res.data.Json.Header;
                        this.model = header;
                        this.model.AccountId = '';
                        this.model.Date = this.$now().format('YYYY-MM-DD');
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    var loading = this.$loading.show();
                    this.$api().post(this.actionLink, this.model).then(res => {
                        if(this.$isValid(res)){
                            this.$router.go(-1);
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            bankList(){
                this.$api().post('accounting/account/types', { AccountTypeNames: ['Bank'] }).then(res => {
                    if(this.$isValid(res)){
                        this.banks = res.data.Json.Accounts;
                    }
                });
            }
        },
    }
</script>